export const imageUrlsChiTietCuaHang = {
  logoQuocKi: "img/vpos/iconTrangChu/quocki.png",
 
};
